<template>
  <div class="search-form">
    <b-row>
      <b-col cols="12">
        <b-form onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              v-model="form.keyword"
              @keyup.enter="query"
              type="search"
              :placeholder="
                $l('table_search_placeholder') ||
                '客户编号/客户名称/创建人 搜索...'
              "
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="openAdvqueryDialog"
                  >
                    {{ $l('INDEX.advanced_search') || '高级搜索' }}
                  </b-button>
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search"></i>
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
            <slot />
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
    <el-dialog
      :title="$l('INDEX.advanced_search') || '高级搜索'"
      :show-close="true"
      :visible.sync="advqueryDialogVisible"
      width="800px"
      :close-on-click-modal="false"
      v-el-dialog-drag
    >
      <el-form ref="form" :model="form" size="small" label-position="top">
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item
              :label="$l('form_has_the_process_ended') || '流程是否结束'"
            >
              <el-checkbox-group v-model="form.doneStatusList">
                <el-checkbox label="0">
                  {{ $l('form_not_finished') || '未结束' }}
                </el-checkbox>
                <el-checkbox label="1">
                  {{ $l('form_ended') || '已结束' }}
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_custApprovalNode') || '审批节点'"
            >
              <dict-select
                :placeholder="
                  $l('form_ple_custApprovalNode') || '请选择审批节点'
                "
                size="small"
                multiple
                clearable
                filterable
                v-model="form.custApprovalNodeList"
                :body="{ dictType: 'custApprovalNode' }"
                url="/sys/common/dict/system"
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item
              :label="$l('form_label_custApprovalRequestType') || '业务类型'"
            >
              <dict-select
                :placeholder="
                  $l('form_ple_custApprovalRequestType') || '请选择业务类型'
                "
                size="small"
                multiple
                clearable
                filterable
                v-model="form.custApprovalRequestTypeList"
                :body="{ dictType: 'custApprovalRequestType' }"
                url="/sys/common/dict/system"
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$l('form_label_custNo') || '客户编号'">
              <el-input
                v-model.trim="form.custNo"
                clearable
                size="small"
                :placeholder="$l('form_placeholder_custNo') || '请输入客户编号'"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$l('form_label_cust') || '负责客户'">
              <dict-select
                v-model="form.custCodeList"
                url="/master/common/dict/customerSelect"
                :placeholder="$l('form_placeholder_cust') || '请选择负责客户'"
                filterable
                clearable
                multiple
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_advquery_createBy') || '创建人'"
            >
              <dict-select
                v-model="form.createByList"
                url="/master/common/dict/baseUserSelect"
                :placeholder="
                  $l('form_placeholder_advquery_createBy') || '请选择创建人'
                "
                clearable
                filterable
                multiple
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-row :gutter="10">
              <el-form-item :label="$l('form_lable_create_date') || '创建时间'">
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.createDateStart"
                    :placeholder="
                      $l('please_label_create_date') || '请选择创建时间'
                    "
                    value-format="yyyy-MM-dd"
                    type="date"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.createDateEnd"
                    :placeholder="
                      $l('please_label_create_date') || '请选择创建时间'
                    "
                    value-format="yyyy-MM-dd"
                    type="date"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAdvqueryDialog">
          {{ $l('INDEX.btn_cancel_query') || '取消查询' }}
        </el-button>
        <el-button size="small" type="warning" @click="reset">
          {{ $l('INDEX.btn_reset_filter') || '重置条件' }}
        </el-button>
        <el-button size="small" type="primary" @click="advquery">
          {{ $l('INDEX.btn_data_retrieval') || '数据检索' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
const initForm = {
  keyword: '',
  custApprovalNodeList: ['1', '2'],
  doneStatusList: ['0'],
}
export default {
  data() {
    return {
      advqueryDialogVisible: false,
      form: { ...initForm },
    }
  },
  mounted() {
    this.query()
  },
  methods: {
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reset')
      }
      this.$emit('query', this.form)
    },
    advquery() {
      this.form.keyword = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    reset() {
      this.form = { ...initForm }
    },
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },
  },
}
</script>
